import { localUrl as appLocalUrl } from './app-path.js';
import AuthService from './services/auth-service';
import FirebaseAuthService from './services/firebase-auth-service';
import { trackGa4ElementEvent } from './analytics/ga4-event-tracker';

const Login = {
	init: () => {
		Login.syncRedirectContext();
		Login.initFormValidation();
		Login.initGoogleSignIn();
		Login.initAppleSignIn();
		Login.initPasswordToggle();
		Login.initLegalLinksTracking();
	},

	getRedirectPath: () => {
		const params = new URLSearchParams(window.location.search);
		const redirect = String(params.get('redirect') || '').trim();

		if (!redirect) {
			return '';
		}

		if (!redirect.startsWith('/') || redirect.startsWith('//')) {
			return '';
		}

		if (redirect.includes('://') || redirect.includes('\\')) {
			return '';
		}

		return redirect;
	},

	syncRedirectContext: () => {
		const redirectPath = Login.getRedirectPath();

		if (!redirectPath) {
			return;
		}

		const registerLink = document.querySelector(
			`a.register-link[href="${appLocalUrl('/cadastro')}"]`,
		);
		if (registerLink) {
			registerLink.setAttribute(
				'href',
				appLocalUrl(`/cadastro?redirect=${encodeURIComponent(redirectPath)}`),
			);
		}
	},

	showMessage: function (container, message, type = 'error', duration = 5000) {
		const messageClass =
			type === 'success' ? 'success-message' : 'error-message';
		const $container = typeof container === 'string' ? $(container) : container;

		$container.find('.success-message, .error-message').remove();

		const $message = $(`<div class="${messageClass}">${message}</div>`);
		$container.prepend($message);

		const fadeDelay = type === 'success' ? 3000 : duration;
		setTimeout(() => {
			$message.fadeOut(() => $message.remove());
		}, fadeDelay);
	},

	initFormValidation: () => {
		const form = document.getElementById('formSendUserLogin');
		const emailInput = document.getElementById('emailInput');
		const passwordInput = document.getElementById('passwordInput');
		const submitBtn = document.getElementById('btnSendUserLogin');
		const emailErrorIcon = document.getElementById('errEmail_icon');
		const emailErrorMsg = document.getElementById('messageStatusLogin');

		if (!form || !emailInput || !passwordInput || !submitBtn) return;

		const validateEmail = email => {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return emailRegex.test(email);
		};

		const checkFormValidity = () => {
			const emailValid = validateEmail(emailInput.value);
			const passwordValid = passwordInput.value.length >= 6;

			if (emailValid && passwordValid) {
				submitBtn.removeAttribute('disabled');
			} else {
				submitBtn.setAttribute('disabled', 'disabled');
			}

			if (emailInput.value && !emailValid) {
				emailErrorIcon.classList.remove('_none');
				emailErrorMsg.classList.remove('_none');
				emailErrorMsg.textContent = 'E-mail inválido';
			} else {
				emailErrorIcon.classList.add('_none');
				emailErrorMsg.classList.add('_none');
			}
		};

		emailInput.addEventListener('input', checkFormValidity);
		passwordInput.addEventListener('input', checkFormValidity);
		emailInput.addEventListener('blur', checkFormValidity);

		form.addEventListener('submit', async e => {
			e.preventDefault();

			const email = emailInput.value.trim();
			const password = passwordInput.value;

			if (!validateEmail(email)) {
				Login.showMessage('.container-form', 'E-mail inválido');
				return;
			}

			if (password.length < 6) {
				Login.showMessage(
					'.container-form',
					'Senha deve ter no mínimo 6 caracteres',
				);
				return;
			}

			submitBtn.value = 'Aguarde...';
			submitBtn.setAttribute('disabled', 'disabled');

			try {
				const result = await AuthService.login(email, password, {
					redirect: Login.getRedirectPath(),
				});

				if (result.success) {
					window.location.href = result.redirect || appLocalUrl('/splash/login');
				} else {
					const translatedMessage = result.error.includes('Login failed')
						? 'Falha no login. Verifique suas credenciais ou tente novamente mais tarde.'
						: result.error;

					Login.showMessage('.container-form', translatedMessage);
					submitBtn.value = 'Continuar';
					submitBtn.removeAttribute('disabled');
				}
			} catch (error) {
				console.error('Login error:', error);
				Login.showMessage(
					'.container-form',
					'Erro ao conectar ao servidor. Tente novamente.',
				);
				submitBtn.value = 'Continuar';
				submitBtn.removeAttribute('disabled');
			}
		});
	},

	initGoogleSignIn: () => {
		const googleBtn = document.getElementById('googleSignIn');
		if (!googleBtn) return;

		googleBtn.addEventListener('click', async e => {
			e.preventDefault();

			if (googleBtn.disabled) return;

			googleBtn.disabled = true;
			googleBtn.style.opacity = '0.6';

			try {
				const firebaseResult = await FirebaseAuthService.signInWithGoogle();

				if (!firebaseResult.success) {
					if (!firebaseResult.error.includes('cancelado')) {
						Login.showMessage('.container-form', firebaseResult.error);
					}
					googleBtn.disabled = false;
					googleBtn.style.opacity = '1';
					return;
				}

				if (!firebaseResult.firebaseToken) {
					Login.showMessage(
						'.container-form',
						'Token do Firebase não retornado. Tente novamente.',
					);
					googleBtn.disabled = false;
					googleBtn.style.opacity = '1';
					return;
				}

				const result = await AuthService.loginGoogle(
					firebaseResult.firebaseToken,
					{
						redirect: Login.getRedirectPath(),
					},
				);

				if (result.success) {
					Login.showMessage(
						'.container-form',
						'Login realizado com sucesso! Redirecionando...',
						'success',
					);

					setTimeout(() => {
						window.location.href = result.redirect || appLocalUrl('/splash/login');
					}, 1000);
				} else {
					Login.showMessage('.container-form', result.error);
					googleBtn.disabled = false;
					googleBtn.style.opacity = '1';
				}
			} catch (error) {
				console.error('Google login error:', error);
				Login.showMessage('.container-form', 'Erro ao conectar ao servidor');
				googleBtn.disabled = false;
				googleBtn.style.opacity = '1';
			}
		});
	},

	initAppleSignIn: () => {
		const appleBtn = document.getElementById('appleSignIn');
		if (!appleBtn) return;

		appleBtn.addEventListener('click', async e => {
			e.preventDefault();

			if (appleBtn.disabled) return;

			appleBtn.disabled = true;
			appleBtn.style.opacity = '0.6';

			try {
				const firebaseResult = await FirebaseAuthService.signInWithApple();

				if (!firebaseResult.success) {
					if (!firebaseResult.error.includes('cancelado')) {
						Login.showMessage('.container-form', firebaseResult.error);
					}
					appleBtn.disabled = false;
					appleBtn.style.opacity = '1';
					return;
				}

				if (!firebaseResult.firebaseToken) {
					Login.showMessage(
						'.container-form',
						'Token do Firebase não retornado. Tente novamente.',
					);
					appleBtn.disabled = false;
					appleBtn.style.opacity = '1';
					return;
				}

				const result = await AuthService.loginApple(
					firebaseResult.firebaseToken,
					null,
					firebaseResult.user,
					{ redirect: Login.getRedirectPath() },
				);

				if (result.success) {
					Login.showMessage(
						'.container-form',
						'Login realizado com sucesso! Redirecionando...',
						'success',
					);

					setTimeout(() => {
						window.location.href = result.redirect || appLocalUrl('/splash/login');
					}, 1000);
				} else {
					Login.showMessage('.container-form', result.error);
					appleBtn.disabled = false;
					appleBtn.style.opacity = '1';
				}
			} catch (error) {
				console.error('Apple Sign In error:', error);
				Login.showMessage('.container-form', 'Erro ao conectar ao servidor');
				appleBtn.disabled = false;
				appleBtn.style.opacity = '1';
			}
		});
	},

	initPasswordToggle: () => {
		const toggleBtns = document.querySelectorAll('.actControlPasswordVisible');

		toggleBtns.forEach(btn => {
			btn.addEventListener('click', e => {
				e.preventDefault();

				const input = btn.previousElementSibling;
				if (!input) return;

				const isPassword = input.type === 'password';
				input.type = isPassword ? 'text' : 'password';

				btn.classList.toggle('fa-eye');
				btn.classList.toggle('fa-eye-slash');
			});
		});
	},

	initLegalLinksTracking: () => {
		document.querySelectorAll('.js-login-legal-link').forEach(link => {
			link.addEventListener('click', () => {
				trackGa4ElementEvent(
					'click_link',
					link.dataset.loginLegalId || link.getAttribute('href'),
					{
						page_location: window.location.href,
						link_url: link.href,
					},
				);
			});
		});
	},
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', Login.init);
} else {
	Login.init();
}

export default Login;
